import { plural } from '@cian/utils';
import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { ContentTabLink } from '../../../components/ContentTabLink';
import { selectAdvices, selectBlogs, selectQuestions, selectTrackingProducts } from '../../../slices';
import { EInfoTabs } from '../ContentTabsContainer';
import { trackClickContent } from '../tracking';

export const useContentTabLink = (activeTab: string): React.ReactNode => {
  const blogs = useSelector(selectBlogs);
  const advices = useSelector(selectAdvices);
  const questions = useSelector(selectQuestions);
  const products = useSelector(selectTrackingProducts);

  const handleClick = useCallback(
    (type: string) => {
      trackClickContent(type, products);
    },
    [products],
  );

  return useMemo(() => {
    if (activeTab === EInfoTabs.Blogs) {
      const text = plural(blogs.totalCount, ['блог', 'блога', 'блогов']);

      return (
        <ContentTabLink href={blogs.link} count={blogs.totalCount} text={text} onClick={() => handleClick('blogs')} />
      );
    }

    if (activeTab === EInfoTabs.Advices) {
      const text = plural(advices.totalCount, ['совет', 'совета', 'советов']);

      return (
        <ContentTabLink
          href={advices.link}
          count={advices.totalCount}
          text={text}
          onClick={() => handleClick('advices')}
        />
      );
    }

    if (activeTab === EInfoTabs.Questions) {
      const text = plural(questions.totalCount, ['вопрос', 'вопроса', 'вопросов']);

      return (
        <ContentTabLink
          href={questions.link}
          count={questions.totalCount}
          text={text}
          onClick={() => handleClick('questions')}
        />
      );
    }

    return null;
  }, [activeTab, advices, blogs, questions, handleClick]);
};
